export var AbsenceReason;
(function (AbsenceReason) {
    AbsenceReason["URLAUB"] = "URLAUB";
    AbsenceReason["KRANKHEIT"] = "KRANKHEIT";
    AbsenceReason["FORTBILDUNG"] = "FORTBILDUNG";
    AbsenceReason["SONSTIGES"] = "SONSTIGES";
})(AbsenceReason || (AbsenceReason = {}));
//# sourceMappingURL=absence-reason.enum.js.map